import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import type { TsCodeType } from '../../types.js'
import { Expression } from '../../data/text-or-code.js'

// StepperOrientations and StepperOrientation are exported from stepper-block.ts

@jsonClass('StepperStepBlock')
export class StepperStepBlock extends Block {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Label',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
		alternativeContentAreaName: 'label',
	})
	labelCode?: TsCodeType

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Step value (for binding in Stepper)',
		codeLanguage: 'ts',
		tsReturnType: () => 'any',
		editorSize: 'singleline',
		isBinding: true,
		isMandatory: () => false,
	})
	bindingCode = new Expression()

	@ScreenEditorInput<StepperStepBlock>({
		inputType: 'code',
		order: 3,
		label: 'Optional',
		codeLanguage: 'ts',
		tsReturnType: () => 'boolean',
		editorSize: 'singleline',
		isBinding: false,
	})
	@jsonProperty(String)
	isOptionalCode: string = 'false'

	@ScreenEditorInput<StepperStepBlock>({
		inputType: 'code',
		order: 4,
		label: 'Editable',
		codeLanguage: 'ts',
		tsReturnType: () => 'boolean',
		editorSize: 'singleline',
		isBinding: false,
	})
	@jsonProperty(String)
	isEditableCode: string = 'true'

	@jsonProperty()
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 5,
		label: 'Load content lazily',
		tab: 'Advanced',
	})
	loadLazily: boolean = false

	getPreviewDirection(): 'row' | 'column' {
		return this.parent?.getPreviewDirection() ?? 'column'
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#b0bec5'
	}

	getTitleColor(): string {
		return '#263238'
	}

	getEditorCategory(): string {
		return 'Additional Form Fields'
	}
}
